import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getSearchType } from '../../api/search'
import { SearchEntity } from '../../api/search/response'

const useSearch = () => {
  const navigate = useNavigate()
  const [searchValue, setSearchValue] = useState<string | undefined>(undefined)

  const { data } = useQuery({
    queryKey: ['get_search_type', searchValue],
    queryFn: () => getSearchType(searchValue ?? ''),
    enabled: !!searchValue,
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (data && searchValue !== '') {
      const { searchType } = data.data
      if (searchType !== 0) {
        navigate(`/${SearchEntity[searchType]}/${searchValue}`)
        setSearchValue('')
      } else {
        navigate('/404')
      }
    }
  }, [data])

  return {
    setSearchValue,
  }
}

export default useSearch
